import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

const gridTemplateDesktop = [
  ['"appBar appBar appBar appBar appBar"'],
  [
    '"conversationContainer conversationContainer conversationContainer conversationContainer conversationContainer"',
  ],
  [
    '"conversationContainer conversationContainer conversationContainer conversationContainer conversationContainer"',
  ],
  [
    '"conversationContainer conversationContainer conversationContainer conversationContainer conversationContainer"',
  ],
  [
    '"conversationContainer  conversationContainer  conversationContainer conversationContainer conversationContainer"',
  ],
  ['". trialBanner trialBanner  trialBanner  trialBanner"'],
  [
    '"conversationBottomBar conversationBottomBar conversationBottomBar conversationBottomBar conversationBottomBar"',
  ],
];

const gridTemplateMobile = [
  ['"appBar appBar appBar"'],
  ['"conversationContainer conversationContainer conversationContainer"'],
  ['"conversationBottomBar conversationBottomBar conversationBottomBar"'],
];

export const useStyles = makeStyles<Theme>((theme) => ({
  root: {
    minHeight: "100%",
    position: "relative",
    pointerEvents: "none",
    display: "grid",
    justifyItems: "center",
    gridTemplateRows: "65px minmax(0, 1fr) 90px",
    gridTemplateAreas: gridTemplateMobile.join(" \n"),
    gridTemplateColumns: "1fr",
    alignItems: "start",
    [theme.breakpoints.up("sm")]: {
      gridTemplateAreas: gridTemplateDesktop.join("\n"),
      gridTemplateRows: "70px 1fr 250px 1fr 40px minmax(10px, auto) 100px",
      gridTemplateColumns: "120px 1fr 1fr 1fr 120px",
      alignItems: "center",
    },
  },
  focusedView: {
    backgroundColor: theme.palette.background.tertiary,
    pointerEvents: "all",
  },

  sidebarButton: {
    pointerEvents: "all",
    marginLeft: "3px",
    [theme.breakpoints.up("md")]: {
      display: "unset",
      margin: "0 1rem",
    },
  },

  locateButton: {
    pointerEvents: "all",
    gridArea: "locateButton",
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "unset",
    },
  },
  freePlanUsageAlert: {
    zIndex: 4,
    position: "fixed",
    pointerEvents: "all",
    gridArea: "freePlanUsageAlert",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },
  trialBanner: {
    pointerEvents: "all",
    gridArea: "trialBanner",
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "unset",
    },
  },
  conversationContainer: {
    gridArea: "conversationContainer",
    position: "relative",
    alignSelf: "start",
    justifySelf: "start",
    width: "100%",
    height: "100%",
  },
  conversationBottomBar: {
    position: "relative",
    pointerEvents: "all",
    gridArea: "conversationBottomBar",
    alignSelf: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "auto",
  },
}));
